import { render } from "./CustomHtml.vue?vue&type=template&id=a3f3d014&ts=true"
import script from "./CustomHtml.vue?vue&type=script&lang=ts"
export * from "./CustomHtml.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__